var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalImpressionCommande",
      attrs: {
        size: "xl",
        title: "Configuration des bons de commande de " + _vm.commande.nom,
        scrollable: "",
        "ok-title": _vm.nomBoutonOk,
        "ok-disabled": !_vm.peutGenererBdC,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.initialiserModale()
        },
        ok: function($event) {
          return _vm.imprimerCommande()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row form-group" },
            [
              _c("label", { attrs: { for: "dpDateCommande" } }, [
                _vm._v("Date de commande :")
              ]),
              _c("v-date-picker", {
                staticClass: "date-picker",
                attrs: {
                  id: "dpDateCommande",
                  disabled: "",
                  popover: { visibility: "click" }
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var inputValue = ref.inputValue
                      var inputEvents = ref.inputEvents
                      return [
                        _c(
                          "input",
                          _vm._g(
                            {
                              domProps: {
                                value: inputValue
                                  ? inputValue
                                  : "Choisir la date..."
                              }
                            },
                            inputEvents
                          )
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.options.DateImpression,
                  callback: function($$v) {
                    _vm.$set(_vm.options, "DateImpression", $$v)
                  },
                  expression: "options.DateImpression"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "row form-group" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("label", { staticClass: "label-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.options.ImprimerTitreCommande,
                      expression: "options.ImprimerTitreCommande"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.options.ImprimerTitreCommande)
                      ? _vm._i(_vm.options.ImprimerTitreCommande, null) > -1
                      : _vm.options.ImprimerTitreCommande
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.options.ImprimerTitreCommande,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerTitreCommande",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerTitreCommande",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "ImprimerTitreCommande", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" Intégrer le nom de la commande ")
              ]),
              _c("label", { staticClass: "label-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.options.ImprimerControleAReception,
                      expression: "options.ImprimerControleAReception"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.options.ImprimerControleAReception
                    )
                      ? _vm._i(_vm.options.ImprimerControleAReception, null) >
                        -1
                      : _vm.options.ImprimerControleAReception
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.options.ImprimerControleAReception,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerControleAReception",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerControleAReception",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "ImprimerControleAReception", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" Intégrer le contrôle à réception ")
              ]),
              _c("label", { staticClass: "label-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.options.ImprimerDatesConso,
                      expression: "options.ImprimerDatesConso"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.options.ImprimerDatesConso)
                      ? _vm._i(_vm.options.ImprimerDatesConso, null) > -1
                      : _vm.options.ImprimerDatesConso
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.options.ImprimerDatesConso,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerDatesConso",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerDatesConso",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "ImprimerDatesConso", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" Intégrer les dates de consommation ")
              ])
            ]),
            _c("div", { staticClass: "col-6" }, [
              _c("label", { staticClass: "label-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.options.SortieXlsx,
                      expression: "options.SortieXlsx"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.options.SortieXlsx)
                      ? _vm._i(_vm.options.SortieXlsx, null) > -1
                      : _vm.options.SortieXlsx
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.options.SortieXlsx,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "SortieXlsx",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "SortieXlsx",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "SortieXlsx", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" Sortie en fichier Excel ")
              ]),
              _c("label", { staticClass: "label-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.options.TrierAlpha,
                      expression: "options.TrierAlpha"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.options.TrierAlpha)
                      ? _vm._i(_vm.options.TrierAlpha, null) > -1
                      : _vm.options.TrierAlpha
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.options.TrierAlpha,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "TrierAlpha",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "TrierAlpha",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "TrierAlpha", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" Trier les lignes par ordre alphabétique ")
              ]),
              _c("label", { staticClass: "label-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.options.ImprimerTVA,
                      expression: "options.ImprimerTVA"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.options.ImprimerTVA)
                      ? _vm._i(_vm.options.ImprimerTVA, null) > -1
                      : _vm.options.ImprimerTVA
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.options.ImprimerTVA,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerTVA",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "ImprimerTVA",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "ImprimerTVA", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" Intégrer le total TTC ")
              ])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { class: _vm.pasDEnvoi ? "col-12" : "col-6" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header flex-start" }, [
                  _c("label", { staticClass: "label-checkbox mb-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.options.ImprimeTout,
                          expression: "options.ImprimeTout"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.options.ImprimeTout)
                          ? _vm._i(_vm.options.ImprimeTout, null) > -1
                          : _vm.options.ImprimeTout
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.options.ImprimeTout,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.options,
                                    "ImprimeTout",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.options,
                                    "ImprimeTout",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.options, "ImprimeTout", $$c)
                            }
                          },
                          function($event) {
                            return _vm.checkAllImprime()
                          }
                        ]
                      }
                    }),
                    _c("span", { staticClass: "ml-2" }, [_vm._v("IMPRESSION")])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  _vm._l(_vm.fournisseurs, function(fournisseur, index) {
                    return _c(
                      "label",
                      { key: index, staticClass: "label-checkbox" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: fournisseur.impression,
                              expression: "fournisseur.impression"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(fournisseur.impression)
                              ? _vm._i(fournisseur.impression, null) > -1
                              : fournisseur.impression
                          },
                          on: {
                            change: function($event) {
                              var $$a = fournisseur.impression,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      fournisseur,
                                      "impression",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      fournisseur,
                                      "impression",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(fournisseur, "impression", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" " + _vm._s(fournisseur.nom) + " ")
                      ]
                    )
                  }),
                  0
                )
              ])
            ]),
            !_vm.pasDEnvoi
              ? _c("div", { staticClass: "col-6" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-header flex-start" }, [
                      _c("label", { staticClass: "label-checkbox mb-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.options.EnvoiTout,
                              expression: "options.EnvoiTout"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.options.EnvoiTout)
                              ? _vm._i(_vm.options.EnvoiTout, null) > -1
                              : _vm.options.EnvoiTout
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.options.EnvoiTout,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.options,
                                        "EnvoiTout",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.options,
                                        "EnvoiTout",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.options, "EnvoiTout", $$c)
                                }
                              },
                              function($event) {
                                return _vm.checkAllEnvoi()
                              }
                            ]
                          }
                        }),
                        _c("span", { staticClass: "ml-2" }, [_vm._v("ENVOI")])
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm._l(_vm.fournisseursPourEnvoi, function(
                          fournisseur,
                          index
                        ) {
                          return _c(
                            "label",
                            { key: index, staticClass: "label-checkbox" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: fournisseur.envoi,
                                    expression: "fournisseur.envoi"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled: !fournisseur.dateLivraisonSouhaitee
                                },
                                domProps: {
                                  checked: Array.isArray(fournisseur.envoi)
                                    ? _vm._i(fournisseur.envoi, null) > -1
                                    : fournisseur.envoi
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = fournisseur.envoi,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            fournisseur,
                                            "envoi",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            fournisseur,
                                            "envoi",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(fournisseur, "envoi", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.abregerTexte(
                                      fournisseur.nom,
                                      !fournisseur.dateLivraisonSouhaitee
                                        ? 30
                                        : 50
                                    )
                                  ) +
                                  " "
                              ),
                              !fournisseur.dateLivraisonSouhaitee
                                ? _c("em", { staticClass: "error ml-2" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-exclamation-triangle mr-1"
                                    }),
                                    _vm._v("Date de livraison manquante")
                                  ])
                                : _vm._e()
                            ]
                          )
                        }),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "txtEmailEnvoiBC" } }, [
                            _vm._v("Votre Email :")
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailEnvoiBC,
                                expression: "emailEnvoiBC"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", id: "txtEmailEnvoiBC" },
                            domProps: { value: _vm.emailEnvoiBC },
                            on: {
                              focus: function($event) {
                                return $event.target.select()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.emailEnvoiBC = $event.target.value
                              }
                            }
                          }),
                          _vm.fournisseursSelectionnesPourEnvoi.length &&
                          !_vm.$v.emailEnvoiBC.required
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v("Ce champ est requis")
                              ])
                            : _vm._e(),
                          _vm.fournisseursSelectionnesPourEnvoi.length &&
                          !_vm.$v.emailEnvoiBC.email
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v("Email invalide")
                              ])
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "txtMailBC" } }, [
                            _vm._v("Votre Message :")
                          ]),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.txtMailBC,
                                expression: "txtMailBC"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "txtMailBC" },
                            domProps: { value: _vm.txtMailBC },
                            on: {
                              focus: function($event) {
                                return $event.target.select()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.txtMailBC = $event.target.value
                              }
                            }
                          })
                        ]),
                        _c("div", { staticClass: "flex-end" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-primary",
                              on: { click: _vm.resetTxtMailBC }
                            },
                            [_vm._v("Réinitialiser le message")]
                          )
                        ])
                      ],
                      2
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }